import React from "react";

//styles
import "./Map.scss";

const Map = () => {
  return (
    <div
      className="location"
      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-easing="ease-in-out"
    >
      <h2>Our Location</h2>
      <span className="hr-line"></span>
      <p>
        We are conveniently located at Iron Wild Fitness in downtown
        Colorado Springs
      </p>

      <div className="map-container">
        <iframe
          className="google-map"
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3107.928601276621!2d-104.82107752349621!3d38.83409597173768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87134519b00d1f4d%3A0xac97bc99e20744b2!2s324%20E%20Pikes%20Peak%20Ave%20Ste%20100%2C%20Colorado%20Springs%2C%20CO%2080903!5e0!3m2!1sen!2sus!4v1781384252866!5m2!1sen!2sus"
          // width="100%"
          height="600"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Map;
